if (!customElements.get('tech-docs')) {
  class TechDocs extends HTMLElement {
    connectedCallback() {
      this.loadMoreButton = this.querySelector('.js-tech-docs-load-more');
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.handleLoadMore.bind(this));
      }
    }

    handleLoadMore() {
      this.querySelectorAll('.tech-docs__item--hidden').forEach((item) => {
        item.classList.remove('tech-docs__item--hidden');
        item.removeAttribute('hidden');
      });

      this.loadMoreButton?.remove();
      this.loadMoreButton = null;
    }
  }

  customElements.define('tech-docs', TechDocs);
}
